/* assets/theme.js - Foundation Theme Global Logic */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    // Progressive enhancement initialization
    initWhatsAppButton();
    initScrollAnimations();
  });

  function initScrollAnimations() {
    // Respect prefers-reduced-motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const revealElements = document.querySelectorAll('.reveal-up, .reveal-scale');
    if (!revealElements.length) return;

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Optional: stop observing once revealed
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.1
    });

    revealElements.forEach(el => observer.observe(el));
  }

  function initWhatsAppButton() {
    var waBtn = document.getElementById('wa-btn');
    var stickyCta = document.querySelector('.sticky-mobile-cta');
    if (!waBtn) return;
    function updateWaPosition() {
      if (stickyCta && stickyCta.classList.contains('visible')) {
        var ctaH = stickyCta.offsetHeight || 72;
        waBtn.style.bottom = (ctaH + 12) + 'px';
      } else {
        waBtn.style.bottom = '24px';
      }
    }
    // Watch for class changes on sticky CTA
    if (stickyCta && window.MutationObserver) {
      new MutationObserver(updateWaPosition).observe(stickyCta, { attributes: true, attributeFilter: ['class'] });
    }
    updateWaPosition();
  }

})();
